<template>
    <div class="categories-block categories-line">
        <p v-if="(title || taxonomy == ('category' || 'projects_cat')) && taxonomy !=='machines_cat'" class="label">Kategori</p>

        <ul v-if="!categories" class="category-list">
            <li class="cat dummy"></li>
            <li class="cat dummy"></li>
            <li class="cat dummy"></li>
        </ul>

        <ul v-else-if="resolvedCategories && resolvedCategories.length > 0" class="category-list">
            <li class="cat " v-for="(cat, i) in resolvedCategories" :key="i">
                <router-link class="cat-name" 
                    v-if="link" 
                    :to="{name: archiveName , query : { kategori: cat.id}}">
                    {{cat.name}}
                </router-link>
                <span v-else class="cat-name"> {{cat.name}}</span>
                <span class="sep">,&nbsp;</span>
            </li>
        </ul>

    </div>
</template>

<script>
import WpLink from '@/components/elements/WpLink';

import { mapGetters } from 'vuex'

export default {
    name: 'categories-block',
    props: { 
        categories: Array, 
        taxonomy: {
            type: String,
            default: 'category',
        },
        title: {
            type: Boolean,
            default: true,
        },
        link: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
        }
    },
    mounted() {
       if(!this.categories){
            this.resolveCategories();
        } 
    },
    methods: {
    },
    computed:{
        ...mapGetters([
            'getCategory'
        ]),
        resolvedCategories(){
            let categories = [];
            if(this.categories){
                this.categories.forEach(catID => {
                    let c = null;
                    c = this.getCategory(catID, this.taxonomy);
                    if(c) categories.push(c);
                });
            }
            return categories;
        },
        archiveName(){
            let name = 'archivePost';
            switch (this.taxonomy) {
                case 'projects_cat':
                    name = 'archive';
                    break;
                case 'machines_cat':
                    name = 'archiveE';
                    break;
                case 'sponsors_cat':
                    name = 'archive';
                    break;
                case 'posttypes':
                    name = 'archive';
                    break;            
            }
            return name;
        }
    },
    components:{
        WpLink
    },
};
</script>

<style lang="scss">
@import "./../../assets/scss/abstracts/_abstracts.scss";

</style>

